if (!customElements.get('mc-foil-media')) {
  customElements.define('mc-foil-media', class extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('.mc-foil-toggle');
      this.desktop = matchMedia('(hover: hover) and (pointer: fine)');
      this.abortController = new AbortController();
      this.requestId = 0;
      this.requested = false;
      const options = { signal: this.abortController.signal };
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse' && this.desktop.matches) this.start();
      }, options);
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse' && this.desktop.matches) this.stop();
      }, options);
      this.addEventListener('pointercancel', (event) => {
        if (event.pointerType === 'mouse') this.stop();
      }, options);
      this.toggle?.addEventListener('click', () => {
        if (this.requested) this.stop();
        else this.start();
      }, options);
      this.desktop.addEventListener('change', () => this.stop(), options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.stop(); }, options);
      window.addEventListener('pagehide', () => this.stop(), options);
      this.observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) this.stop();
      });
      this.observer.observe(this);
    }
    start() {
      const requestId = ++this.requestId;
      this.requested = true;
      this.video.muted = true;
      if (!this.video.src) this.video.src = this.video.dataset.src;
      this.updateToggle(true);
      this.video.play().then(() => {
        if (requestId !== this.requestId) return;
        if (this.requested && !document.hidden) this.setAttribute('data-playing', '');
        else this.stop();
      }).catch(() => { if (requestId === this.requestId) this.stop(); });
    }
    updateToggle(playing) {
      if (!this.toggle) return;
      this.toggle.setAttribute('aria-pressed', String(playing));
      this.toggle.querySelector('span').textContent = playing ? this.toggle.dataset.pauseLabel : this.toggle.dataset.playLabel;
    }
    stop() {
      this.requestId++;
      this.requested = false;
      this.removeAttribute('data-playing');
      this.updateToggle(false);
      if (this.video) {
        this.video.pause();
        try { this.video.currentTime = 0; } catch (_) {}
      }
    }
    disconnectedCallback() {
      this.stop();
      this.abortController?.abort();
      this.abortController = null;
      this.observer?.disconnect();
    }
  });
}
